import { useContext } from "react";
import { Container, Card, Table } from "react-bootstrap";
import userContext from "./Context";
import "./Alldata.css";

function Alldata() {

  const { users, total } = useContext(userContext);

  return (
    <div className="alldata-bg d-flex justify-content-center align-items-center">
      <Container>
        <Card className="alldata-card shadow-lg p-4 mx-auto">
          <h2 className="text-center mb-4">All Users Data</h2>

          <Table striped bordered hover responsive className="text-center">
            <thead className="table-primary">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Password</th>
                <th>Balance</th>
              </tr>
            </thead>

            <tbody>
              {users.map((user, index) => (
                <tr key={index}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.password}</td>
                  <td className="fw-bold text-primary">₹ {total}</td>
                </tr>
              ))}
            </tbody>
          </Table>

        </Card>
      </Container>
    </div>
  );
}

export default Alldata;
